
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jusia-academy/[...parts]",
      function () {
        return require("private-next-pages/jusia-academy/[...parts].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jusia-academy/[...parts]"])
      });
    }
  